import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import {  Link } from "react-router-dom";
import {Table} from "reactstrap";
import { Card, CardTitle  } from "reactstrap";
import { Redirect } from "react-router-dom";
import Axios from "axios";
import base_URL from "../../base_URL";
import { Container } from "@material-ui/core";

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userService: [],
    };

    this.loadService = this.loadService.bind(this);
    this.deleteUser = this.deleteUser.bind(this);
    this.deleteUserService = this.deleteUserService.bind(this);
  }

  deleteUser = async (id) => {
    await Axios.delete(`${base_URL}/del/${id}`);
    this.loadService();
  };

  deleteUserService = async (id) => {
    await Axios.delete(`${base_URL}/del/service/${id}`);
    this.loadService();
  };

  loadService = async () => {
    await Axios.get(`${base_URL}/All`, {
     
    }).then((response) => {
      this.setState({
        userService: response.data.reverse(),
      });
    });
  };

  componentDidMount() {
   
    this.loadService();
  }

  render() {
 
  if (localStorage.getItem("Admin1token") == null)
      return <Redirect to="/login" />;

    return (
      <Container  id="container">
        <Card body style={{ margin: "20px" }} id="Card">
          <CardTitle>
            <h1>All Users</h1>
          </CardTitle>
        </Card>

        <Paper>
          <TableContainer style={{ maxHeight: 500 }}>
            <Table responsive className="table border shadow">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">User Id</th>
                  <th scope="col">FirstName</th>
                  <th scope="col">LastName</th>
                  <th scope="col">Email</th>
                  <th scope="col">Password</th>
                  <th scope="col">Roles</th>
                 
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {this.state.userService.map((user, index) => (
                  <tr>
                    <th scope="row">{index + 1}</th>
                    <td>{user.id}</td>
                    <td>{user.firstName}</td>
                    <td>{user.lastName}</td>
                    <td>{user.email}</td>
                    <td>{user.password}</td>
                    <td>{user.roles}</td>
                    
                    <td>
                     
                      <Link
                        type="button"
                        class="btn btn-outline-danger"
                        onClick={() => this.deleteUser(user.id)}
                      >
                        Delete
                      </Link>


                      <Link
                        type="button"
                        class="btn btn-warning"
                        onClick={() => this.deleteUserService(user.id)}
                      >
                        Remove 
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableContainer>
        </Paper>
      </Container>
    );
  }
}


export default Users;
